export default __webpack_public_path__ + "static/animated-logo-468445bda3ccd304d404288534b0def6.gif";